const deviceInfo = window.__DEVICE__;

const generateFallbackDeviceId = (): string => {
    const stored = sessionStorage.getItem("sso_deviceId");
    if (stored) return stored;
    const random = Array.from(crypto.getRandomValues(new Uint8Array(10)))
        .map(b => b.toString(16).padStart(2, "0")).join("");
    const fallbackId = `noid${random}`;
    sessionStorage.setItem("sso_deviceId", fallbackId);
    return fallbackId;
};

export const Device = {
    model: deviceInfo?.model || "",
    os: deviceInfo?.os || "",
    isDarkMode: deviceInfo?.isDarkMode || false,
    language: deviceInfo?.language || "ko",
    inset: {
        statusBarHeight: deviceInfo?.inset?.statusBarHeight || 0,
        navigationBarHeight: deviceInfo?.inset?.navigationBarHeight || 0
    },
    countryCd: deviceInfo?.countryCd || "",
    deviceId: deviceInfo?.deviceId || generateFallbackDeviceId()
}